import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Grid, Dropdown, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {findUserAgency} from '../../../common/util/user';
import {dealerOrderStatus, dealerOrderTypes} from '../../../common/constants/lists';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import TrackingSchedule from '../trackingSchedule';
import Detail from './detail';
import TrackingTechDetailsModal from './modal/TrackingTechDetailsModal';
import './tracking.scss';

class Tracking extends Component {
  constructor(props) {
    super(props);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleExportClick = this.handleExportClick.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerOrdersTracking, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.restoreDealerOrdersTracking();
    this.props.getAllAgencies();
  }

  handleFilterChange(event, data) {
    this.props.editDealerOrdersTrackingFilter(data.id, data.value.toUpperCase());
  }

  handleStatusChange(event, data) {
    this.props.editDealerOrdersTrackingFilter(data.id, data.value);
  }

  handleSearchClick() {
    const {orderType, orderCode, user, partCode, status, userAgency} = this.props;
    if (!orderCode && !partCode && !status) {
      this.props.addMessageBoxError(
        'El código de repuesto o el código de pedido son requeridos si desea realizar la búsqueda de todos los estados'
      );
      return false;
    }
    this.props.getDealersOrdersManagement({
      orderType,
      orderCode,
      user,
      partCode,
      status,
      'userDealer': userAgency.dealerId,
      'dealer': userAgency.dealerId,
      'agency': userAgency.code,
    });
  }

  handleExportClick() {
    const {orderType, orderCode, user, partCode, status, userAgency} = this.props;
    if (!orderCode && !partCode && !status) {
      this.props.addMessageBoxError(
        'El código de repuesto o el código de pedido son requeridos si desea realizar la búsqueda de todos los estados'
      );
      return false;
    }
    this.props.downloadDealerOrderManagement({
      orderType,
      orderCode,
      user,
      partCode,
      status,
      'userDealer': userAgency.dealerId,
      'dealer': userAgency.dealerId,
      'agency': userAgency.code,
    });
  }

  handleClearClick() {
    this.props.restoreDealerOrdersTracking();
  }

  blockFilter() {
    const {orderCode, partCode, status} = this.props;

    return !orderCode && !partCode && !status;
  }

  render() {
    const {userAgency, downloading, loading, orderType, status, partCode, user, orderCode} = this.props;

    if (_.isEmpty(userAgency)) {
      return (
        <Card raised fluid>
          <h2>Estimado usuario, su agencia no está habilitada en el sistema.</h2>
        </Card>
      );
    }

    return (
      <div className='dealer-orders-tracking'>
        <Card raised fluid className='tracking-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <h2 style={{'display': 'inline-flex', 'alignItems': 'center'}}>
                  Seguimiento de Pedidos - Concesionarios
                  <TrackingTechDetailsModal />
                </h2>
                <div className='user-agency'>
                  {userAgency.dealerName} | {userAgency.description}
                </div>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <Button secondary disabled={loading} content='LIMPIAR' onClick={this.handleClearClick} />
                <Button
                  primary
                  disabled={loading || downloading}
                  content='EXPORTAR A EXCEL'
                  onClick={this.handleExportClick}
                />
                <Button primary disabled={loading} content='BUSCAR' onClick={this.handleSearchClick} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column textAlign='left'>
                <label htmlFor='orderType'>
                  <strong>Tipo de pedido</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  id='orderType'
                  placeholder='Tipo de pedido'
                  options={dealerOrderTypes}
                  value={orderType}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='status'>
                  <strong>Estado</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  id='status'
                  placeholder='Estado'
                  options={dealerOrderStatus}
                  value={status}
                  onChange={this.handleStatusChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='partCode'>
                  <strong>Código parte</strong>
                </label>
                <Input
                  fluid
                  id='partCode'
                  placeholder='Código de parte'
                  maxLength='20'
                  value={partCode}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='partCode'>
                  <strong>Número de pedido</strong>
                </label>
                <Input
                  fluid
                  id='orderCode'
                  placeholder='Número de Pedido'
                  maxLength='8'
                  value={orderCode}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='user'>
                  <strong>Usuario</strong>
                </label>
                <Input
                  fluid
                  id='user'
                  placeholder='Usuario'
                  maxLength='30'
                  disabled={this.blockFilter()}
                  value={user}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Detail />
        <TrackingSchedule />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {dealerId, dealerAgency} = state.session;
  const {agencies} = state.dealer;
  const userAgency = findUserAgency(agencies, dealerId, dealerAgency);

  return {
    'permissions': state.session.permissions,
    'userAgency': userAgency || {},
    'downloading': state.dealerOrdersTracking.downloading,
    'loading': state.dealerOrdersTracking.loading,
    'orderType': state.dealerOrdersTracking.orderType,
    'status': state.dealerOrdersTracking.status,
    'user': state.dealerOrdersTracking.user,
    'partCode': state.dealerOrdersTracking.partCode,
    'orderCode': state.dealerOrdersTracking.orderCode,
  };
};

const {
  getAllAgencies,
  restoreDealerOrdersTracking,
  editDealerOrdersTrackingFilter,
  getDealersOrdersManagement,
  downloadDealerOrderManagement,
  addMessageBoxError,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getAllAgencies,
  restoreDealerOrdersTracking,
  editDealerOrdersTrackingFilter,
  getDealersOrdersManagement,
  downloadDealerOrderManagement,
  addMessageBoxError,
  navigateTo,
})(Tracking);
